import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import Helper from '../Helper';
import { APPLICATION_JSON } from '../../middleware/types';
import { useDispatch, useSelector } from 'react-redux';
const Accept = (props) => {

  const dispatch = useDispatch();
  
  useEffect(() => {
    let cookie_consent = getCookie("acceptCookieTermsCookie");
    console.log("accept cookie_consent",cookie_consent);
    if(cookie_consent != ""){
      document.getElementById("i-agree").classList.remove("d-block");
        document.getElementById("i-agree").classList.add("d-none");
    }else{
      document.getElementById("i-agree").classList.remove("d-none");
        document.getElementById("i-agree").classList.add("d-block");
    }
  }, [])

async function setCookieBannersession(cookieStatus){
  var actionUrl = "api/rest/cb/profile/set-cookie-banner-status";
  var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
  var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({cookieBannerStatus:cookieStatus}))
  // dispatch(UpdateCookieBannerAction("true"))
  
}


// Create cookie
function setCookie(cname, cvalue, exdays) {
  const date = new Date();
  date.setTime(date.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ date.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
 
}

// Delete cookie
function deleteCookie(cname) {
  const date = new Date();
  date.setTime(date.getTime() + (24*60*60*1000));
  let expires = "expires="+ date.toUTCString();
  document.cookie = cname + "=;" + expires + ";path=/";
}

// Read cookie
function getCookie(cname) {
  let name = cname + "=";
  let encodeCookie = encodeURIComponent(document.cookie)
  let decodedCookie = decodeURIComponent(encodeCookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
  }
  return "";
}

// Set cookie consent
function acceptCookieConsent(event){
  event.preventDefault();
  document.getElementById("i-agree").classList.add("d-none");
    deleteCookie('acceptCookieTermsCookie');
    setCookie('acceptCookieTermsCookie', true, 30);
    setCookieBannersession(true);
}





  return (
   <div id="i-agree"  className='d-none' >
	{/* className={`${props?.isAccept == "true"? 'd-none':'d-block'}`} */}
    <div id="cookieBanner" className="d-flex justify-content-center align-items-center">
         <span class="cookieTerms-text me-2">
             We use cookies to provide you with a great user experience. By using our site, you accept our 
              <Link  className="acceptStyle" to="/help/privacy-and-security" > use of cookies </Link>.  
             You can review our <Link to="/help/privacy-and-security"  className="acceptStyle">cookie and privacy policy here</Link>.
         </span>
         <form  onSubmit={acceptCookieConsent}>
         <input type="submit" class="cookieTerms-button" value="I Accept" />
         </form>
    </div>	
     
</div>
  )
}

export default Accept